import { getAppointmentStatusKey, getPaymentStatusKey } from './appointmentStatusUtils';

const toHourMinute = (rawTime) => {
  if (!rawTime || typeof rawTime !== 'string') return null;
  const parts = rawTime.split(':');
  return parts.length < 2 ? rawTime : `${parts[0]}:${parts[1]}`;
};

// Only a visibility hint: whether the cancellation is late, and what it costs, is decided by the
// server and shown in the confirmation dialog before anything happens.
export function canCustomerCancel(appointment, now = Date.now()) {
  const key = getAppointmentStatusKey(appointment?.status);
  // A booking held while the customer pays can be let go too, freeing the slot straight away.
  if (key !== 'pending' && key !== 'confirmed' && key !== 'awaitingPayment') {
    return false;
  }

  const from = toHourMinute(appointment?.period?.from);
  if (!appointment?.date || !from) {
    return false;
  }

  const start = new Date(`${appointment.date}T${from}:00`);
  if (Number.isNaN(start.getTime())) {
    return false;
  }

  return start.getTime() > now;
}

// Checkout only opens for confirmed bookings or ones held for payment: an on-request booking
// waits for the store, and a completed one is settled at the till. After a deposit, what is
// left can be paid online too, once the booking is confirmed.
export function canPayOnlineNow(appointment) {
  if (appointment?.hasUnpricedServices === true) return false;

  const paymentKey = getPaymentStatusKey(appointment?.paymentStatus);
  const statusKey = getAppointmentStatusKey(appointment?.status);
  if (paymentKey === 'depositPaid') {
    return statusKey === 'confirmed' && Number(appointment?.amountDue) > 0;
  }

  return Number(appointment?.amountDue) > 0
    && (paymentKey === 'unpaid' || paymentKey === 'pendingPayment')
    && (statusKey === 'confirmed' || statusKey === 'awaitingPayment');
}

export const isPayingTheBalance = (appointment) => getPaymentStatusKey(appointment?.paymentStatus) === 'depositPaid';
